/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Topics_From_BothInputs */



/**
* | output |
* | --- |
* | "from the transcript and the notes" |
*
* @param {Meeting_Topics_From_BothInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_topics_from_both = /** @type {((inputs?: Meeting_Topics_From_BothInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Topics_From_BothInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("uit het transcript en de notities")
	if (locale === "fr") return /** @type {LocalizedString} */ ("à partir de la transcription et des notes")
	return /** @type {LocalizedString} */ ("from the transcript and the notes")
});